import hasAddresses from './utilities/hasAddresses';
import hasPhones from './utilities/hasPhones';

const adminDepartment = (adminDepartmentJson) => {
  const properties = {
    ...adminDepartmentJson.attributes,
    guid: adminDepartmentJson.guid,
  };
  return Object.assign(
    properties,
    hasAddresses(adminDepartmentJson.attributes.addresses),
    hasPhones(adminDepartmentJson.attributes.phones),
  );
};

export default adminDepartment;
